"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

var _icon = _interopRequireDefault(require("@mapbox/mr-ui/icon"));

var _tag = _interopRequireDefault(require("../tag/tag"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

// check if client body width is >= 640
var isMM = typeof document !== 'undefined' ? document.body.clientWidth >= 640 : false;

var NavigationAccordion = /*#__PURE__*/function (_React$Component) {
  _inherits(NavigationAccordion, _React$Component);

  var _super = _createSuper(NavigationAccordion);

  function NavigationAccordion() {
    var _this;

    _classCallCheck(this, NavigationAccordion);

    _this = _super.call(this);

    _defineProperty(_assertThisInitialized(_this), "setToggle", function (label) {
      var activeToggles = _this.state.activeToggles;
      var labelIndex = activeToggles.indexOf(label);

      if (labelIndex > -1) {
        // label already exists, remove it from activeToggles
        activeToggles.splice(labelIndex, 1);
      } else {
        // label does not exist, add it to activeToggles
        activeToggles.push(label);
      }

      _this.setState({
        activeToggles: activeToggles
      });
    });

    _defineProperty(_assertThisInitialized(_this), "renderTag", function (page) {
      return /*#__PURE__*/_react.default.createElement("span", {
        className: "ml6 relative",
        style: {
          top: -1
        }
      }, /*#__PURE__*/_react.default.createElement(_tag.default, _extends({
        theme: page.tag
      }, page.customTagProps, {
        small: true,
        icon: true
      })));
    });

    _this.state = {
      activeToggles: []
    };
    return _this;
  } // add item or remove it if it already exists


  _createClass(NavigationAccordion, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;

      // if device width is >= 640
      // determine which section is active and activate its toggle
      var _this$props = this.props,
          parentPage = _this$props.parentPage,
          navigation = _this$props.navigation;

      if (isMM) {
        navigation.forEach(function (nav) {
          if (nav.path === parentPage) {
            _this2.setToggle(nav.title);
          }
        });
      }
    }
  }, {
    key: "renderHeader",
    value: function renderHeader(page, hasChildren, isActiveToggle, isActiveSection, sectionId, external) {
      var _this3 = this;

      var title = page.title,
          path = page.path;
      return /*#__PURE__*/_react.default.createElement("div", {
        className: (0, _classnames.default)('px12 flex-parent txt-uppercase txt-fancy round-full w-full color-darken75', {
          'bg-blue-faint color-blue': isActiveSection,
          'flex-parent flex-parent--space-between-main': hasChildren
        })
      }, /*#__PURE__*/_react.default.createElement("a", {
        href: path,
        className: "flex-child flex-child--grow  color-blue-on-hover py6 py3-mm",
        style: {
          letterSpacing: '0.025em'
        }
      }, title, page.tag && this.renderTag(page), external && /*#__PURE__*/_react.default.createElement("span", {
        className: "ml3 color-darken50 relative",
        style: {
          top: '-1px'
        }
      }, /*#__PURE__*/_react.default.createElement(_icon.default, {
        name: 'share',
        inline: true
      }))), hasChildren && /*#__PURE__*/_react.default.createElement("button", {
        className: "flex-child flex-child--no-shrink color-blue-on-hover px12 px0-mm",
        onClick: function onClick() {
          return _this3.setToggle(title);
        },
        "aria-label": "Toggle ".concat(title, " menu"),
        "aria-controls": sectionId,
        "aria-expanded": isActiveToggle
      }, /*#__PURE__*/_react.default.createElement(_icon.default, {
        name: isActiveToggle ? 'chevron-up' : 'chevron-down',
        inline: true
      })));
    }
  }, {
    key: "renderBody",
    value: function renderBody(subItems, activeItem, sectionId) {
      var _this4 = this;

      var parentPage = this.props.parentPage;
      var subItemEls = subItems.filter(function (page) {
        return page.path !== parentPage;
      }).map(function (page) {
        return /*#__PURE__*/_react.default.createElement("li", {
          // Required on parents containing tags to prevent unwanted scrollbars on IE
          className: (0, _classnames.default)('mb3', {
            'scroll-hidden': page.tag
          }),
          key: page.title
        }, /*#__PURE__*/_react.default.createElement("a", {
          className: (0, _classnames.default)('inline-block w-full color-blue-on-hover', {
            'color-blue': activeItem === page.path
          }),
          href: page.path
        }, page.title, page.tag && _this4.renderTag(page)));
      });
      return /*#__PURE__*/_react.default.createElement("ul", {
        id: sectionId,
        className: "mb12 ml12"
      }, subItemEls);
    }
  }, {
    key: "render",
    value: function render() {
      var _this5 = this;

      var _this$props2 = this.props,
          navigation = _this$props2.navigation,
          parentPage = _this$props2.parentPage,
          location = _this$props2.location;
      var activeToggles = this.state.activeToggles;
      var activeItem = location.pathname;
      var items = navigation.map(function (pageSection) {
        var title = pageSection.title,
            id = pageSection.id,
            path = pageSection.path,
            pages = pageSection.pages,
            hideSubpages = pageSection.hideSubpages,
            external = pageSection.external; // the section has sub pages

        var hasPages = pages && pages.length > 0 && !hideSubpages; // the section's toggle is active

        var isActiveToggle = activeToggles.indexOf(title) > -1; // the section is active

        var isActiveSection = path === parentPage;
        var sectionId = "menu-".concat(id);
        return {
          header: _this5.renderHeader(pageSection, hasPages, isActiveToggle, isActiveSection, sectionId, external),
          body: isActiveToggle && hasPages ? _this5.renderBody(pages, activeItem, sectionId) : []
        };
      });
      var sidebarItems = items.map(function (item, index) {
        return /*#__PURE__*/_react.default.createElement("li", {
          key: index
        }, item.header, item.body);
      });
      return /*#__PURE__*/_react.default.createElement("nav", {
        className: "mx-neg12"
      }, /*#__PURE__*/_react.default.createElement("ul", null, sidebarItems));
    }
  }]);

  return NavigationAccordion;
}(_react.default.Component);

exports.default = NavigationAccordion;
NavigationAccordion.propTypes = {
  navigation: _propTypes.default.arrayOf(_propTypes.default.shape({
    title: _propTypes.default.string.isRequired,
    path: _propTypes.default.string.isRequired,
    id: _propTypes.default.string.isRequired,
    tag: _propTypes.default.string,
    hideSubpages: _propTypes.default.bool,
    // needed for /help/tutorials and /help/troublehshooting
    pages: _propTypes.default.array
  })).isRequired,
  location: _propTypes.default.object.isRequired,
  parentPage: _propTypes.default.string.isRequired
};